import debounce from "lodash/debounce";
import { queryClient } from "./index";

export const invalidateProjectCounters = debounce(
  (projectId) => {
    queryClient.invalidateQueries(["project-counters", projectId]);
  },
  2000,
  { leading: true, trailing: true }
);

export const invalidateTimeRecordFilters = debounce(
  (projectId) => {
    queryClient.invalidateQueries(["time-record-available-filters", projectId]);
  },
  2000,
  { leading: true, trailing: true }
);

export const invalidateTimeRecordTotalInfo = debounce((parentType, parentId) => {
  queryClient.invalidateQueries(["time-records-user-total", parentType, parentId]);
});

export const invalidateExpenseFilters = debounce(
  (projectId) => {
    queryClient.invalidateQueries(["expense-available-filters", projectId]);
  },
  2000,
  { leading: true, trailing: true }
);

export const invalidateExpenseTotalInfo = debounce((parentType, parentId) => {
  queryClient.invalidateQueries(["expenses-user-total", parentType, parentId]);
});

export const invalidateProjectProgress = debounce(
  (projectId) => {
    queryClient.invalidateQueries(["project-progress", projectId]);
  },
  2000,
  { leading: true, trailing: true }
);
